import AdminUsersPage from "./users";

export default AdminUsersPage;
